import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import ZoomIn from '@alltrails/denali/icons/ZoomIn';
import ZoomOut from '@alltrails/denali/icons/ZoomOut';
import useMap from '../../hooks/useMap';

type ZoomButtonsProps = {
  onZoomInClick?: () => void;
  onZoomOutClick?: () => void;
};

const ZoomButtons = ({ onZoomInClick, onZoomOutClick }: ZoomButtonsProps) => {
  const intl = useIntl();
  const map = useMap();

  return (
    <>
      <IconButton
        icon={{ Component: ZoomIn }}
        onClick={() => {
          onZoomInClick?.();
          map?.zoomIn();
        }}
        title={intl.formatMessage({ defaultMessage: 'Zoom map in' })}
        variant="elevated"
      />
      <IconButton
        icon={{ Component: ZoomOut }}
        onClick={() => {
          onZoomOutClick?.();
          map?.zoomOut();
        }}
        title={intl.formatMessage({ defaultMessage: 'Zoom map out' })}
        variant="elevated"
      />
    </>
  );
};

export default ZoomButtons;
